import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerProfile from "@/pages/CustomerProfile";
import NewLead from "@/pages/NewLead";
import Reports from "@/pages/Reports";
import Orders from "@/pages/Orders";
import OrderForm from "@/pages/OrderForm";
import OrderDetail from "@/pages/OrderDetail";
import CustomerMaster from "@/pages/CustomerMaster";
import CustomerMasterDetail from "@/pages/CustomerMasterDetail";
import Team from "@/pages/Team";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/customers" element={<Protected><Customers /></Protected>} />
      <Route path="/customers/:id" element={<Protected><CustomerProfile /></Protected>} />
      <Route path="/new" element={<Protected><NewLead /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/orders" element={<Protected adminOnly><Orders /></Protected>} />
      <Route path="/orders/new" element={<Protected adminOnly><OrderForm /></Protected>} />
      <Route path="/orders/:id" element={<Protected adminOnly><OrderDetail /></Protected>} />
      <Route path="/orders/:id/edit" element={<Protected adminOnly><OrderForm /></Protected>} />
      <Route path="/customer-master" element={<Protected adminOnly><CustomerMaster /></Protected>} />
      <Route path="/customer-master/:id" element={<Protected adminOnly><CustomerMasterDetail /></Protected>} />
      <Route path="/team" element={<Protected adminOnly><Team /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
